import React from "react";
import PropTypes from "prop-types";

import { Button } from "semantic-ui-react";

import useRedtailUrl from "components/Crm/hooks/useRedtailUrl";

export default function EditTagInRedtailButton({ onMenuClose }) {
  const redtailUrl = useRedtailUrl();

  return (
    <Button
      icon="edit"
      content="Edit in Redtail"
      onClick={() => {
        onMenuClose();
        const win = window.open(`${redtailUrl}/contacts/tags`, "_blank");
        win.focus();
      }}
    />
  );
}

EditTagInRedtailButton.propTypes = {
  onMenuClose: PropTypes.func.isRequired,
};
